import React from "react"
import SbEditable from "storyblok-react"
import { Select, Input } from "gatsby-theme-gba"

const LocationSelectEditable = ({ blok }) => {
  const locations = blok.locations.map(location => ({
    value: location.slug,
    name: location.content.name,
  }))

  if (locations.length > 1) {
    locations.unshift([
      {
        value: "",
        name: "",
      },
    ])
  }

  const locationsFormElement =
    locations.length === 1 ? (
      <Input
        type="hidden"
        label={blok.label}
        name="recipient"
        required={true}
        value={locations[0].value}
      />
    ) : (
      <Select
        name="recipient"
        label={blok.label}
        value={blok.value}
        placeholder={blok.placeholder}
        options={locations}
        required={true}
        flex={blok.flex}
      />
    )

  return <SbEditable content={blok}>{locationsFormElement}</SbEditable>
}

export default LocationSelectEditable
